import React from "react";
import { v4 as uuidv4 } from "uuid";
import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";
import "./sample.sass";
import SidebarLayout from "../shared/SidebarLayout";
import SidebarTitle from "../shared/SidebarTitle";
import SidebarList from "../shared/SidebarList";
import { ISampleViewData } from "../../models/sample/SampleViewData";
import { ISidebarDetail, SidebarDetail } from "../../models/shared/SidebarDetail";
import sampleListStore from "../../flux/stores/sample/ListStore";
import sampleByIdStore from "../../flux/stores/sample/ByIdStore";
import sampleActions from "../../flux/actions/SampleActions";
import triggerNotifications from "../../utilities/TriggerNotifications";
import MeasurementOverviewLanding from "./MeasurementOverviewLanding";
import { Status } from "../../models/sample/Status";
import History from "../../utilities/History";
import { IActionHeaderEditData } from "../../models/shared/ActionHeaderData";
import actionHeaderActions from "../../flux/actions/ActionHeaderActions";
import SidebarCreate from '../shared/SidebarCreate';
import { SampleFormData } from '../../models/sample/SampleFormData';
import sampleFormStore from '../../flux/stores/sample/FormStore';
import loadingActions from '../../flux/actions/LoadingActions';
import sampleDeleteStore from '../../flux/stores/sample/DeleteStore';

import { Input } from "@abb/abb-common-ux-react";
import sampleListStoreNew from "../../flux/stores/sample/ListStoreNew";
import sampleStatusStore from "../../flux/stores/sample/SampleStatusStore";
import productActions from "../../flux/actions/ProductActions";
import gradeActions from "../../flux/actions/GradeActions";
import productListStore from "../../flux/stores/product/ListStore";
import gradeListStore from "../../flux/stores/grade/ListStore";
import { IProductViewData } from "../../models/product/ProductViewData";
import { IGradeViewData } from "../../models/grade/GradeViewData";
import sourceActions from "../../flux/actions/SourceActions";
import sourceListStore from "../../flux/stores/source/ListStore";
import { ISourceViewData } from "../../models/source/SourceViewData";
import "../../../node_modules/react-datepicker/src/stylesheets/datepicker.scss";
import SampleFilter from "../shared/SampleFilter";
import moment from "moment";
interface IState {
  isFullSidebarVisible: boolean;
  activeId: string;
  activeItem: ISampleViewData;
  listData: ISidebarDetail[];
  inputSampleName: string;
  showPopup: boolean;
  isComplete: boolean;
  nameError: boolean;
  buttonDisabled: boolean;
  searchValue: string;
  showFilter: boolean;
  selectFromDate: string;
  selectToDate: string;
  selectedDateRange: any[];
  gradeList: any[];
  selectedGrade: any[];
  measurementStatusList: any[];
  selectedMeasurementStatus: any[];
  productDataList: any[];
  productList: any[];
  selectedProduct: any[];
  sourceList: any[];
  selectedSource: any[];
  hasFiltersChanged: boolean;
}

export default class MeasurementOverviewIndex extends React.Component<{ location: any }, IState> {
  private _mount = false;
  private _reloadFirst = true;
  private _id = "";
  private _list: ISidebarDetail[] = [];
  private _activeItem: ISampleViewData;
  private _activeId: string;
  private _message: string[];
  private _isValid: boolean = true;
  private _page: number = 1;
  private _pageToScroll: number = 0;
  private _hasMore: boolean = true;
  private _listRef: any;
  private _listData: ISidebarDetail[] = [];
  private _datetimeFormat = 'YYYY-MM-DD HH:mm:ss';
  private daterange = CONSTANTS.DATE_RANGES;
  private _gradeList: any[] = [];
  private _productList: any[] = [];
  private _sourceList: any[] = [];
  private _ALL = "ALL";
  private _defaultDrpOption = [{ value: this._ALL, label: this._ALL }];

  constructor(props: any) {
    super(props);
    this._listRef = React.createRef();
    const activeItem = this.props.location.state?.sampleData;
    const activeId = this.props.location.state?.sampleData.id;
    const isComplete = this.props.location.state?.isComplete;
    const searchValue = this.props.location.state?.searchValue || "";
    this._page = this.props.location.state?.pageToScroll || this._page;
    this._pageToScroll = this.props.location.state?.pageToScroll || 0;
    this.state = {
      isFullSidebarVisible: true,
      searchValue,
      activeId,
      activeItem,
      listData: [],
      inputSampleName: "",
      showPopup: false,
      isComplete: this.props.location.state?.isComplete,
      nameError: false,
      buttonDisabled: false,
      showFilter: this.props.location.state?.selectedFilters?.showFilter || false,
      selectedDateRange: this.props.location.state?.selectedFilters?.selectedDateRange || [],
      selectFromDate: this.props.location.state?.selectedFilters?.selectFromDate || null,
      selectToDate: this.props.location.state?.selectedFilters?.selectToDate || null,
      gradeList: [],
      selectedGrade: this.props.location.state?.selectedFilters?.selectedGrade || this._defaultDrpOption,
      measurementStatusList: [],
      selectedMeasurementStatus: this.props.location.state?.selectedFilters?.selectedMeasurementStatus || this._defaultDrpOption,
      productDataList: [],
      productList: [],
      selectedProduct: this.props.location.state?.selectedFilters?.selectedProduct || this._defaultDrpOption,
      sourceList: [],
      selectedSource: this.props.location.state?.selectedFilters?.selectedSource || this._defaultDrpOption,
      hasFiltersChanged: this.props.location.state?.selectedFilters?.hasFiltersChanged || false
    }
    this._mount = false;
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    gradeActions.getAll(true, 1, CONSTANTS.PAGE_SIZE_ALL, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, "").then(() => {
      this.setState({
        gradeList: this._gradeList
      }, () => this.forceUpdate());
    });
    gradeListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        state.gradeDataList.result.forEach((grade: IGradeViewData) => {
          const gradeList = {
            label: grade.name,
            value: grade.id
          }
          this._gradeList.push(gradeList);
        })
      }
    });

    productActions.getAll(true, 1, CONSTANTS.PAGE_SIZE_ALL, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, "").then(() => {
      this.setState({
        productList: this._productList
      }, () => this.forceUpdate());
    });
    productListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        state.productDataList.result.forEach((product: IProductViewData) => {
          const data = {
            label: product.name,
            value: product.id
          }
          this._productList.push(data);
        })
        this.setState({
          productDataList: state.productDataList.result
        });
      }
    });

    sourceActions.getAll(1, CONSTANTS.PAGE_SIZE_ALL, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, "").then(() => {

      this.setState({
        sourceList: this._sourceList
      }, () => this.forceUpdate());
    });
    sourceListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {

        state.sourceDataList.result.forEach((source: ISourceViewData) => {
          const data = {
            label: source.name,
            value: source.id
          }

          this._sourceList.push(data)
        })
      }
    });

    sampleActions.getSampleStatus().then(() => {

      loadingActions.setLoading(false);
    }).catch(() => {
      loadingActions.setLoading(false);
    });
    sampleStatusStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      const dropdownList: any[] = []
      state.data.forEach((source: ISourceViewData) => {
        const dropdown = {
          label: source.name,
          value: source.id
        }
        dropdownList.push(dropdown)
      })
      this.setState({
        measurementStatusList: [...dropdownList]
      })
    });



    sampleListStoreNew.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._listData = [];
        if (state.sampleDataList.currentPage === state.sampleDataList.totalPages || state.sampleDataList.totalRecords == 0) {
          this._hasMore = false;
        } else {
          this._hasMore = true;
        }
        const data = state.sampleDataList.result as ISampleViewData[];
        data.forEach((element) => {
          this._listData.push(new SidebarDetail(element.id, element.name, element.status.name));
        });
      }
    });




    sampleFormStore.on(CONSTANTS.CHANGE_EVENT, state => {
      if (this._mount) {
        this._message = state.message;
      }
    })

    sampleListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._list = [];
        if (state.sampleDataList.currentPage === state.sampleDataList.totalPages || state.sampleDataList.totalRecords == 0) {
          this._hasMore = false;
        } else {
          this._hasMore = true;
        }
        const data = state.sampleDataList.result as ISampleViewData[];
        data.forEach((element) => {
          this._list.push(new SidebarDetail(element.id, element.name, element.status.name));
        });
      }
    });

    sampleListStoreNew.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._list = [];
        if (state.sampleDataList.currentPage === state.sampleDataList.totalPages || state.sampleDataList.totalRecords == 0) {
          this._hasMore = false;
        } else {
          this._hasMore = true;
        }
        const data = state.sampleDataList.result as ISampleViewData[];
        data.forEach((element) => {
          this._list.push(new SidebarDetail(element.id, element.name, element.status.name));
        });
      }
    });


    sampleByIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._activeItem = state.sampleData;
        this._activeId = state.sampleData.id;
      }
    });

    sampleDeleteStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._reloadFirst = state.reload;
        this.setState({
          activeId: ""
        }, () => setTimeout(() => {
          History.push(CONSTANTS.SAMPLE_INDEX_URL);
          this.getAll();
        }, CONSTANTS.NOTIFICATION_TIMEOUT))
      }
    });
    this.getAll();
  }

  private getAll() {
    loadingActions.setLoading(true);
    const pageSize = this._pageToScroll ? (this._pageToScroll * 30) : 30;

    const payload: any = {
      isAll: true,
      page: 1,
      pageSize: pageSize,
      sort: "SampleDate",
      order: "Desc",
      filter: this.state.searchValue ? `Name:${this.state.searchValue}` : "",
      startDateTime: this.state.selectFromDate ? new Date(this.state.selectFromDate).toUTCString() : new Date(Date.now() + (-10*365*24*3600*1000)).toUTCString(),
      endDateTime: this.state.selectToDate ? new Date(this.state.selectToDate).toUTCString() : new Date(Date.now() + (60*1000)).toUTCString(),
      gradeIds: this.state.selectedGrade[0]?.value === this._defaultDrpOption[0]?.value ? null : this.state.selectedGrade?.map(({ value }) => value),
      productIds: this.state.selectedProduct[0]?.value === this._defaultDrpOption[0]?.value ? null : this.state.selectedProduct?.map(({ value }) => value),
      measurementStatusIds: this.state.selectedMeasurementStatus[0]?.value === this._defaultDrpOption[0]?.value ? null : this.state.selectedMeasurementStatus?.map(({ value }) => value),
      sourceIds: this.state.selectedSource[0]?.value === this._defaultDrpOption[0]?.value ? null : this.state.selectedSource?.map(({ value }) => value),
    }
    const requestId = uuidv4();
    sampleActions.postAll(payload, requestId).then(() => {
      this.setState({ listData: this._list }
        , () => {
          if(this.props.location.state && this.props.location.state.scrollPosition){
            this._listRef.current.scrollTop =  this.props.location.state.scrollPosition 
          } else {
            if(this._listRef.current){
              this._listRef.current.scrollTop = 0;
            }
          }
          loadingActions.setLoading(false);
          if (this.state.listData.length > 0) {
            let firstItem = this.state.activeId !== "" ? this.state.activeId : this.state.listData[0].id;
            if (this._reloadFirst) {
              this.triggerGetById(firstItem);
            } else {
              this.triggerGetById(this._id);
            }
          } else {
            const data: IActionHeaderEditData = {
              moduleName: CONSTANTS.MODULE_SAMPLE,
              editData: {},
              deleteTitle: "",
              deleteId: "",
              isEnableViewAll: false,
              exportId: "",
              deleteRequestId: uuidv4(),
              deleteMessage: "",
              isEnableReport: false
            };
            actionHeaderActions.edit(data).then();
            triggerNotifications.error("Sample not assigned")
          }
        });
    }).catch(() => loadingActions.setLoading(false));
  }

  private triggerGetById(id: string) {
    sampleActions.getById(id).then(() => {

      const numberValue: any = this._activeItem.name.match(/\d+/g);
      const stringValue: any = this._activeItem.name.match(/[a-zA-Z]+/g);
      let inputName = "";
      if (!numberValue || (numberValue?.length > 1) || (stringValue?.length > 1)) {
        inputName = this._activeItem.name;
      } else {
        if (stringValue) {
          const firstChar: any = this._activeItem.name.charAt(0);
          if (isNaN(firstChar)) {
            inputName = `${stringValue}${parseInt(numberValue) + 1}`;
          } else {
            inputName = `${parseInt(numberValue)}${stringValue}`;
          }
        } else {
          inputName = `${parseInt(numberValue) + 1}`;
        }
      }
      this.setState({
        inputSampleName: inputName,
        activeItem: this._activeItem,
        activeId: this._activeId,
      }, () => {
        const selectedFilters = {
          selectFromDate: this.state.selectFromDate,
          selectToDate: this.state.selectToDate,
          selectedDateRange: this.state.selectedDateRange,
          selectedMeasurementStatus: this.state.selectedMeasurementStatus,
          selectedGrade: this.state.selectedGrade,
          selectedProduct: this.state.selectedProduct,
          selectedSource: this.state.selectedSource,
          showFilter: this.state.showFilter,
          hasFiltersChanged: this.state.hasFiltersChanged
        }
        if (this.state.activeItem.status != null) {
          const receivedData = this.state.activeItem;
          const editData = new SampleFormData(
            true,
            uuidv4(),
            receivedData.id,
            receivedData.name,
            receivedData.description,
            receivedData.product?.id,
            receivedData.source?.id,
            receivedData.orderId,
            receivedData.setId,
            receivedData.sampleDate,
            receivedData.source?.name,
            receivedData.product?.name,
            "",
            receivedData.product?.grade?.id,
            receivedData.testPlan?.id
          );
          const data: IActionHeaderEditData = {
            moduleName: CONSTANTS.MODULE_SAMPLE,
            editData,
            deleteTitle: receivedData.name,
            deleteId: this.state.activeId,
            exportId: this.state.activeId,
            deleteRequestId: uuidv4(),
            deleteMessage: receivedData.name,
            isEnableReport: this.state.activeItem.status.name === Status.NOTMEASURED ? false : true,
          };
          actionHeaderActions.edit(data).then();
          
          if (this.state.activeItem.status.name === Status.NOTMEASURED) {
            History.replace(
              {
                pathname: CONSTANTS.SAMPLE_INDEX_URL,
                state: { sampleData: this.state.activeItem, scrollPosition: this._listRef.current.scrollTop, searchValue: this.state.searchValue, pageToScroll: this._page, selectedFilters: selectedFilters }
              }
            );
          } else if (this.state.activeItem.status.name === Status.MEASURED
            || this.state.activeItem.status.name === Status.REJECTED
            || this.state.activeItem.status.name === Status.APPROVED

          ) {
            History.push(
              {
                pathname: CONSTANTS.MEASUREMENT_OVERVIEW_URL,
                state: { sampleData: this.state.activeItem, scrollPosition: this._listRef.current.scrollTop, measurementId: "", searchValue: this.state.searchValue, pageToScroll: this._page, selectedFilters: selectedFilters }
              }
            );
          } else if (this.state.activeItem.status.name === Status.MEASURING
            || this.state.activeItem.status.name === Status.PAUSED) {
            History.push(
              {
                pathname: CONSTANTS.MEASUREMENT_INDEX_URL,
                state: { sampleData: this.state.activeItem, scrollPosition: this._listRef.current.scrollTop, searchValue: this.state.searchValue, pageToScroll: this._page, selectedFilters: selectedFilters }
              }
            );
          } else if (this.state.activeItem.status.name === Status.STOPPED
            && this.state.isComplete) {
            History.push(
              {
                pathname: CONSTANTS.MEASUREMENT_OVERVIEW_URL,
                state: { sampleData: this.state.activeItem, scrollPosition: this._listRef.current.scrollTop, measurementId: "", searchValue: this.state.searchValue, pageToScroll: this._page, selectedFilters: selectedFilters }
              }
            );
          } else {
            History.push(
              {
                pathname: CONSTANTS.SAMPLE_INDEX_URL,
                state: { sampleData: this.state.activeItem, scrollPosition: this._listRef.current.scrollTop, searchValue: this.state.searchValue, pageToScroll: this._page, selectedFilters: selectedFilters }
              }
            );
          }
        } else {
          History.replace(
            {
              pathname: CONSTANTS.SAMPLE_INDEX_URL,
              state: { sampleData: this.state.activeItem, scrollPosition: this._listRef.current.scrollTop, searchValue: this.state.searchValue, pageToScroll: this._page, selectedFilters: selectedFilters }
            }
          );
          const receivedData = this.state.activeItem;
          const editData = new SampleFormData(
            true,
            uuidv4(),
            receivedData.id,
            receivedData.name,
            receivedData.description,
            receivedData.product?.id,
            receivedData.source?.id,
            receivedData.orderId,
            receivedData.setId,
            receivedData.sampleDate,
            receivedData.source?.name,
            receivedData.product?.name,
            receivedData.product?.name,
            receivedData.product?.grade?.id,
            receivedData.testPlan?.id
          );
          const data: IActionHeaderEditData = {
            moduleName: CONSTANTS.MODULE_SAMPLE,
            editData,
            deleteTitle: receivedData.name,
            deleteId: this.state.activeId,
            exportId: this.state.activeId,
            deleteRequestId: uuidv4(),
            deleteMessage: receivedData.name,
            isEnableReport: this.state.activeItem.status.name === Status.NOTMEASURED ? false : true,
          };
          actionHeaderActions.edit(data).then();
        }

      })
    }).catch((error) => {
      triggerNotifications.errors(error.message, error.data).then();
    });
  }

  private onSelectLink = (id: string) => {
    this.setState({ activeId: id });
    this.triggerGetById(id);
  };

  public onActivate = () => {
    this.setState({
      showPopup: true
    });
  }

  public onDeactivate = () => {
    this.setState({
      showPopup: false,
      inputSampleName: this.state.activeItem.name,
      nameError: false,
      buttonDisabled: false
    });
  }

  public onSave = (e: any, val: boolean) => {
    if (e !== null) {
      if (e.keyCode === 13) {
        this.setState({
          showPopup: false,
        });
        const sampleData = this.state.activeItem;
        const tempName = this.state.inputSampleName.replace(/ +(?= )/g, '').trim();
        sampleData.name = tempName;
        if (this._isValid) {
          this.setState({
            inputSampleName: tempName
          }, () => {
            const sampleBody = new SampleFormData(false, uuidv4(), CONSTANTS.DefaultGuid, this.state.inputSampleName, sampleData.description,
              sampleData.product?.id, sampleData.source?.id, sampleData.orderId, sampleData.setId, sampleData.sampleDate, "", "","",sampleData?.product?.grade?.id,sampleData.testPlan?.id);
            sampleActions.post(sampleBody).then(() => {
              triggerNotifications.success(this._message).then();
              this.setState({
                inputSampleName: ""
              })
              this._list = [];
              this.getAll();
            }).catch((error) => {
              triggerNotifications.errors(error.message, error.data).then();
              this.setState({
              })
            })
          })
        }
      }
    } else {
      this.setState({
        showPopup: false,
      });
      const sampleData = this.state.activeItem;
      const tempName = this.state.inputSampleName.replace(/ +(?= )/g, '').trim();
      sampleData.name = tempName;
      if (this._isValid) {
        this.setState({
          inputSampleName: tempName
        }, () => {
          const sampleBody = new SampleFormData(false, uuidv4(), CONSTANTS.DefaultGuid, this.state.inputSampleName, sampleData.description,
            sampleData.product?.id, sampleData.source?.id, sampleData.orderId, sampleData.setId, sampleData.sampleDate, "", "","",sampleData?.product?.grade?.id,sampleData.testPlan?.id);
          sampleActions.post(sampleBody).then(() => {
            triggerNotifications.success(this._message).then();
            this.setState({
              inputSampleName: ""
            })
            this._list = [];
            this.getAll();
          }).catch((error) => {
            triggerNotifications.errors(error.message, error.data).then();
            this.setState({
            })
          })
        })
      }
    }
  }

  public setName = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "")
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (val.trim() && !rgFile.test(val)) {
      this.setState({ nameError: false, inputSampleName: val }, this.validate)
    } else {
      this.setState({ nameError: true, inputSampleName: val }, this.validate)
    }
  }
  validate(): void {
    if (!this.state.nameError && this.state.inputSampleName.trim() && this.state.inputSampleName !== "") {
      this._isValid = true;
      this.setState({
        buttonDisabled: false
      })
    } else {
      this._isValid = false;
      this.setState({
        buttonDisabled: true
      })
    }
  }


  public onsearch = (value: any) => {
    if (value.length >= CONSTANTS.SEARCH_LENGTH || value.length === 0) {
      loadingActions.setLoading(true);
      const pageSize = 30;

      const payload: any = {
        isAll: true,
        page: 1,
        pageSize: pageSize,
        sort: "SampleDate",
        order: "Desc",
        filter: value ? `Name:${value}` : '',
        startDateTime: this.state.selectFromDate ? new Date(this.state.selectFromDate).toUTCString() : new Date(Date.now() + (-10*365*24*3600*1000)).toUTCString(),
        endDateTime: this.state.selectToDate ? new Date(this.state.selectToDate).toUTCString() : new Date(Date.now() + (60*1000)).toUTCString(),
        gradeIds: this.state.selectedGrade[0]?.value === this._defaultDrpOption[0]?.value ? null : this.state.selectedGrade?.map(({ value }) => value),
        productIds: this.state.selectedProduct[0]?.value === this._defaultDrpOption[0]?.value ? null : this.state.selectedProduct?.map(({ value }) => value),
        measurementStatusIds: this.state.selectedMeasurementStatus[0]?.value === this._defaultDrpOption[0]?.value ? null : this.state.selectedMeasurementStatus?.map(({ value }) => value),
        sourceIds: this.state.selectedSource[0]?.value === this._defaultDrpOption[0]?.value ? null : this.state.selectedSource?.map(({ value }) => value),
      }
      const requestId = uuidv4();
      sampleActions.postAll(payload, requestId).then(() => {
        loadingActions.setLoading(false);
        this.setState({ listData: this._list, searchValue: value }
          , () => {
            const firstItem = this.state.listData[0];
            if (this.state.listData.length > 0) {
              this.triggerGetById(firstItem.id);
            }
          })
      })
    } else {
      this.setState({ searchValue: value })
    }
  }


  public fetchMore = () => {
    loadingActions.setLoading(true);
    this._page = this._page + 1;
    const pageSize = 30;

    const payload: any = {
      isAll: true,
      page: this._page,
      pageSize: pageSize,
      sort: "SampleDate",
      order: "Desc",
      filter: this.state.searchValue ? `Name:${this.state.searchValue}` : "",
      startDateTime: this.state.selectFromDate ? new Date(this.state.selectFromDate).toUTCString() : new Date(Date.now() + (-10*365*24*3600*1000)).toUTCString(),
      endDateTime: this.state.selectToDate ? new Date(this.state.selectToDate).toUTCString() : new Date(Date.now() + (60*1000)).toUTCString(),
      gradeIds: this.state.selectedGrade[0]?.value === this._defaultDrpOption[0]?.value ? null : this.state.selectedGrade?.map(({ value }) => value),
      productIds: this.state.selectedProduct[0]?.value === this._defaultDrpOption[0]?.value ? null : this.state.selectedProduct?.map(({ value }) => value),
      measurementStatusIds: this.state.selectedMeasurementStatus[0]?.value === this._defaultDrpOption[0]?.value ? null : this.state.selectedMeasurementStatus?.map(({ value }) => value),
      sourceIds: this.state.selectedSource[0]?.value === this._defaultDrpOption[0]?.value ? null : this.state.selectedSource?.map(({ value }) => value),
    }
    const requestId = uuidv4();
    sampleActions.postAll(payload, requestId).then(() => {
      loadingActions.setLoading(false);
      const data = [...this.state.listData, ...this._list];
      this.setState({ listData: data });
    }).catch(() => loadingActions.setLoading(false));
  }

  public showSelectFilterHandler = () => {
    this.setState({
      showFilter: !this.state.showFilter
    })
  }

  private productChangeHandler = (val: any) => {
    if (val.length === 0) {
      val = this._defaultDrpOption
    }
    if (val.find((x: { value: string; }) => x.value !== this._defaultDrpOption[0].value)) {
      const inx = val.findIndex((x: { value: string; }) => x.value === this._defaultDrpOption[0].value);
      if (inx !== -1) { val.splice(inx, 1); }
    }
    var arrayGrade: any[];
    arrayGrade = [];
    var arrayTestplan: any[];
    arrayTestplan = [];
    this.setState({
      selectedProduct: val
    }, this.postAll)

  }

  private gradeChangeHandler = (val: any) => {
    if (val.length === 0) {
      val = this._defaultDrpOption
    }
    if (val.find((x: { value: string; }) => x.value !== this._defaultDrpOption[0].value)) {
      const inx = val.findIndex((x: { value: string; }) => x.value === this._defaultDrpOption[0].value);
      if (inx !== -1) { val.splice(inx, 1); }
    }
    var newArray: any[];
    newArray = [];
    var arrayTestplan: any[];
    arrayTestplan = [];
    let filteredProduct: any[] = [];
    val.map((item: any) => {
      const tempValue = this.state.productDataList.filter(product => { return product.grade.id === item.value });
      filteredProduct = [...filteredProduct, ...tempValue]
    })
    const filteredProductData: any[] = [];
    filteredProduct.forEach((product: IProductViewData) => {
      filteredProductData.push({
        label: product.name,
        value: product.id
      });
    })
    this.setState({
      selectedGrade: val,
      selectedProduct: this._defaultDrpOption,
      productList: filteredProductData
    }, this.postAll)

  }

  postAll = () => {
    const pageSize = (this._pageToScroll + 1) * 30;
    const payload: any = {
      isAll: true,
      page: 1,
      pageSize: pageSize,
      sort: "SampleDate",
      order: "Desc",
      filter: this.state.searchValue ? `Name:${this.state.searchValue}` : "",
      startDateTime: this.state.selectFromDate ? new Date(this.state.selectFromDate).toUTCString() : new Date(Date.now() + (-10*365*24*3600*1000)).toUTCString(),
      endDateTime: this.state.selectToDate ? new Date(this.state.selectToDate).toUTCString() : new Date(Date.now() + (60*1000)).toUTCString(),
      gradeIds: this.state.selectedGrade[0]?.value === this._defaultDrpOption[0]?.value ? null : this.state.selectedGrade?.map(({ value }) => value),
      productIds: this.state.selectedProduct[0]?.value === this._defaultDrpOption[0]?.value ? null : this.state.selectedProduct?.map(({ value }) => value),
      measurementStatusIds: this.state.selectedMeasurementStatus[0]?.value === this._defaultDrpOption[0]?.value ? null : this.state.selectedMeasurementStatus?.map(({ value }) => value),
      sourceIds: this.state.selectedSource[0]?.value === this._defaultDrpOption[0]?.value ? null : this.state.selectedSource?.map(({ value }) => value)
    }
    const requestId = uuidv4();
    sampleActions.postAll(payload, requestId).then(() => {
      loadingActions.setLoading(false);
      this.setState({
        listData: this._listData,
        hasFiltersChanged: true
      }
        , () => {
          const firstItem = this.state.listData[0];
          if (this._reloadFirst) {
            if (this.state.listData.length > 0) {
              this.triggerGetById(firstItem.id);
            } else {
              const data: IActionHeaderEditData = {
                moduleName: CONSTANTS.MODULE_SAMPLE,
                editData: {},
                deleteTitle: "",
                deleteId: "",
                isEnableViewAll: false,
                exportId: "",
                deleteRequestId: uuidv4(),
                deleteMessage: "",
                isEnableReport: true
              };
              actionHeaderActions.edit(data).then();
            }
          } else {
            this.triggerGetById(this._id);
          }
        });
    }).catch(() => loadingActions.setLoading(false));

  }

  dateRangeHandler = (val: any) => {
    this.setState({
      selectedDateRange: val,
      selectedMeasurementStatus: this._defaultDrpOption,
      selectedGrade: this._defaultDrpOption,
      selectedProduct: this._defaultDrpOption,
      selectedSource: this._defaultDrpOption
    }, this.postAll);
    let fromDate: any = "", toDate: any = "";
    let selectedDate = val[0]?.value;
    toDate = moment().format(this._datetimeFormat);
    switch (selectedDate) {
      case 1:
        fromDate = moment().subtract(1, 'd').format(this._datetimeFormat);
        break;
      case 2:
        fromDate = moment().subtract(7, 'd').format(this._datetimeFormat);
        break;
      case 3:
        fromDate = moment().subtract(30, 'd').format(this._datetimeFormat);
        break;
      case 4:
        fromDate = this.state.selectFromDate ? this.state.selectFromDate : moment().subtract(1, 'd').format(this._datetimeFormat);
        toDate = this.state.selectToDate ? this.state.selectToDate : moment().format(this._datetimeFormat);
        break;
      default:
        fromDate = moment().subtract(1, 'd').format(this._datetimeFormat);
        break;
    }

    if (moment(fromDate) >= moment(toDate)) {
      triggerNotifications.errors([CONSTANTS.FROM_GRATER_TO]).then();
    }
    else {
      this.setState({
        selectFromDate: fromDate,
        selectToDate: toDate
      })
    }
  }

  measurementStatusHandler = (values: any) => {
    if (values.length === 0) {
      values = this._defaultDrpOption
    }
    if (values.find((x: { value: string; }) => x.value !== this._defaultDrpOption[0].value)) {
      const inx = values.findIndex((x: { value: string; }) => x.value === this._defaultDrpOption[0].value);
      if (inx !== -1) { values.splice(inx, 1); }
    }
    this.setState({
      selectedMeasurementStatus: values
    }, this.postAll);
  }

  private sourceChangeHandler = (val: any) => {
    if (val.length === 0) {
      val = this._defaultDrpOption
    }
    if (val.find((x: { value: string; }) => x.value !== this._defaultDrpOption[0].value)) {
      const inx = val.findIndex((x: { value: string; }) => x.value === this._defaultDrpOption[0].value);
      if (inx !== -1) { val.splice(inx, 1); }
    }
    this.setState({
      selectedSource: val
    }, this.postAll)
  }

  private setTrendCustomFromDate = (val: any) => {
    if (moment(val).format(this._datetimeFormat) >= this.state.selectToDate) {
      triggerNotifications.errors([CONSTANTS.FROM_GRATER_TO]).then();
    }
    this.setState({ selectFromDate: moment(val).format(this._datetimeFormat) }, this.postAll)
  }
  private setTrendCustomToDate = (val: any) => {
    if (this.state.selectFromDate >= moment(val).format(this._datetimeFormat)) {
      triggerNotifications.errors([CONSTANTS.FROM_GRATER_TO]).then();
    }
    this.setState({ selectToDate: moment(val).format(this._datetimeFormat) }, this.postAll)
  }

  private reset = () => {
    this.setState({
      selectedDateRange: [],
      selectFromDate: null,
      selectToDate: null,
      selectedGrade: this._defaultDrpOption,
      selectedMeasurementStatus: this._defaultDrpOption,
      selectedProduct: this._defaultDrpOption,
      selectedSource: this._defaultDrpOption,
      hasFiltersChanged: false,
      showFilter: false
    }, () => {
      this.getAll()
    });
  }

  
  private clearAllFilters = () => {
    this.setState({
      selectedDateRange: [],
      selectFromDate: null,
      selectToDate: null,
      selectedGrade: this._defaultDrpOption,
      selectedMeasurementStatus: this._defaultDrpOption,
      selectedProduct: this._defaultDrpOption,
      selectedSource: this._defaultDrpOption,
      hasFiltersChanged: false,
      showFilter: true
    }, () => {
      this.getAll()
    });
  }


  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="layout-margin">
            <SidebarLayout
              isFullSidebarVisible={this.state.isFullSidebarVisible}
              isShowSelectFilter={true}
              reSet={this.reset}
              showFilter={this.state.showFilter}
              hasFiltersChanged={this.state.hasFiltersChanged}
              showSelectFilterHandler={this.showSelectFilterHandler}
              handlePanelToggle={() =>
                this.setState({
                  isFullSidebarVisible: !this.state.isFullSidebarVisible,
                })
              }
              selectedSource={[]}
              trendDropdownSourceList={[]}
            >
              <SidebarTitle title={CONSTANTS.MODULE_SAMPLE} />
              {(this.state.listData.length && (this.state.activeId !== "")) ?
                <SidebarCreate setName={(val: string) => this.setName(val)}
                  inputName={this.state.inputSampleName} isShowPopup={this.state.showPopup}
                  module={CONSTANTS.MODULE_SAMPLE}
                  nameError={this.state.nameError}
                  isButtonDisabled={this.state.buttonDisabled}
                  onActivate={this.onActivate} onSave={this.onSave} onDeactivate={this.onDeactivate} />
                : null
              }
              <div className="px-2 text-center">
                <Input
                  type="discreet"
                  inputAttributes={{ 'autoFocus': "true" }}
                  dataType="text"
                  placeholder={t(CONSTANTS.LABEL_SEARCH)}
                  icon="abb/search"
                  value={this.state.searchValue}
                  onValueChange={this.onsearch}
                />
              </div>
              <SidebarList onSelectLink={this.onSelectLink}
                listData={this.state.listData}
                activeId={this.state.activeId}
                fetchMore={this.fetchMore}
                listRef={this._listRef}
                hasMore={this._hasMore}
              />
            </SidebarLayout>
            {
                (this.state.isFullSidebarVisible && this.state.showFilter) &&
              <SampleFilter

                selectFromDate={this.state.selectFromDate}
                selectToDate={this.state.selectToDate}
                selectedDateRange={this.state.selectedDateRange}
                gradeList={this.state.gradeList}
                selectedGrade={this.state.selectedGrade}
                measurementStatusList={this.state.measurementStatusList}
                selectedMeasurementStatus={this.state.selectedMeasurementStatus}
                productList={this.state.productList}
                selectedProduct={this.state.selectedProduct}
                sourceList={this.state.sourceList}
                selectedSource={this.state.selectedSource}

                dateRangeHandler={this.dateRangeHandler}
                setTrendCustomFromDate={this.setTrendCustomFromDate}
                setTrendCustomToDate={this.setTrendCustomToDate}
                measurementStatusHandler={this.measurementStatusHandler}
                gradeChangeHandler={this.gradeChangeHandler}
                productChangeHandler={this.productChangeHandler}
                sourceChangeHandler={this.sourceChangeHandler}
                clearAllFilters={this.clearAllFilters}
                reSet={this.reset}
                hasFiltersChanged={this.state.hasFiltersChanged}
                showSelectFilterHandler={this.showSelectFilterHandler}
              />
            }
            <div className={this.state.isFullSidebarVisible ? "main-layout ml-3 no-padding" : "main-full-layout float-right"}>
              <MeasurementOverviewLanding />
            </div>
          </div>
        )}
      </Translation>
    );
  }
}